module.exports = __webpack_public_path__ + "media/fotorama/fotorama-9556e533.png";